import { useContext, useState } from 'react';

import { Button, Card, CardActions, CardContent, CardHeader } from '@mui/material';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { CLASS_STUDENTS } from '../../config/apiPaths';
import { RosterContext } from '../../context/RosterContext';
import { getUrlParams, getUrls } from '../../utils/url';
import { StyledLoadingButton } from '../forms/LoadingButton';
import { RosterTableData } from './types';

const DeleteModalCard = styled(Card)`
    width: 500px;
`;

const StyledCardHeader = styled(CardHeader)`
    background-color: ${(props) => props.theme.colors.primary.main};
    color: white;
`;

const StyledCardActions = styled(CardActions)`
    display: flex;
    justify-content: flex-end;
`;

export interface RosterDeleteModalProps {
    data: RosterTableData | undefined;
}

const RosterDeleteModal: React.FC<RosterDeleteModalProps> = ({ data }) => {
    const { selectedStudentId, setOpenDeleteModal, rosterData, setRosterData } = useContext(RosterContext);
    const { api } = getUrls();
    const userUuid = getUrlParams().user_uuid ?? window.localStorage.getItem('user_uuid');
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { t } = useTranslation('roster');
    const { enqueueSnackbar } = useSnackbar();

    const getStudentIdValue = () => {
        if (data && data.student_id) return data.student_id;
    };

    const getUserNameValue = () => {
        if (data && data.user_name) return data.user_name;
    };

    const handleClose = () => {
        setOpenDeleteModal(false);
    };

    const handleSubmit = async () => {
        setIsLoading(true);
        const studentId = getStudentIdValue();
        try {
            await axios.delete(`${api}${CLASS_STUDENTS}?studentId=${studentId}`, { headers: { token: userUuid } });
            const newRoster = rosterData.roster.slice();
            const removeIndex = newRoster.findIndex((record) => record.student_id === selectedStudentId);
            newRoster.splice(removeIndex, 1);
            setRosterData({ loading: false, roster: newRoster });
            setOpenDeleteModal(false);
        } catch (error) {
            console.error(error);
            enqueueSnackbar(t('alert-content-8', { userName: getUserNameValue() }), { variant: 'error' });
            setOpenDeleteModal(false);
        }
    };
    return (
        <>
            <DeleteModalCard>
                <StyledCardHeader title={t('Delete')}></StyledCardHeader>
                <CardContent>
                    {t('confirm-delete-message')}
                    <div>{getUserNameValue()}</div>
                </CardContent>
                <StyledCardActions>
                    <Button variant={'outlined'} onClick={handleClose} disabled={isLoading}>
                        {t('Cancel')}
                    </Button>
                    <StyledLoadingButton variant={'contained'} onClick={handleSubmit} loading={isLoading}>
                        {t('Delete')}
                    </StyledLoadingButton>
                </StyledCardActions>
            </DeleteModalCard>
        </>
    );
};

export default RosterDeleteModal;
